import { render, staticRenderFns } from "./profileapproval.vue?vue&type=template&id=61f2940a"
import script from "./profileapproval.vue?vue&type=script&lang=js"
export * from "./profileapproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports